import { useQuery } from "@tanstack/react-query";
import { GetMemberParams } from "../types/types";
import { getNok } from "../api/nok";

const useGetNok = ({
  page,
  searchKey,
  area,
  sort,
  limit,
  groupId,
}: GetMemberParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "Nok",
      `page-${page}`,
      `searchKey-${searchKey}`,
      `area-${area}`,
      `sort-${sort}`,
      `limit-${limit}`,
      `groupId-${groupId}`,
    ],
    queryFn: () => getNok({ page, searchKey, area, sort, limit, groupId }),
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isSuccess };
};

export default useGetNok;
